import { gql, useMutation } from '@apollo/client';

import { BatchableContext } from '@work4all/models/lib/DataProvider';

export const SET_SETTING_MUTATION = gql`
  mutation SetSetting($setting: InputSetting!) {
    setSetting(input: $setting) {
      name
      value
    }
  }
`;

export interface SetSettingMutationVariables {
  setting: {
    name: string;
    personal: boolean;
    value: string | null;
  };
}

export function useSetSettingMutation() {
  return useMutation<void, SetSettingMutationVariables, BatchableContext>(
    SET_SETTING_MUTATION,
    {
      context: {
        batch: false,
      },
    }
  );
}

export const DELETE_SETTING_MUTATION = gql`
  mutation DeleteSetting($setting: InputSetting!) {
    deleteSetting(setting: $setting)
  }
`;

export interface DeleteSettingMutationVariables {
  setting: {
    name: string;
    personal: boolean;
  };
}

export function useDeleteSettingMutation() {
  return useMutation<void, DeleteSettingMutationVariables>(
    DELETE_SETTING_MUTATION
  );
}
